import { Button, Label, TextInput, useValidatedState } from 'acma-spa';
import React, { useEffect } from 'react';
import { Invoice } from '../api';
import * as yup from 'yup';

export interface InvoiceDetailsProps {
    r: Invoice | null
    errors: string
    onChange: (r: Invoice | null) => void
    counter: number
    disabled: boolean
}

export const InvoiceDetails: React.FC<InvoiceDetailsProps> = (props):any => {

    const invoiceSchema: yup.SchemaOf<Invoice> = yup.object().shape({
        invoiceNumber: yup.string().min(9).defined().label("Invoice Number"),
    }).defined();

    let blank = Invoice.fromJS({ invoiceNumber: '', amount: 0 });
    const [invoice, setInvoice, errors, validate] = useValidatedState<Invoice>(props.r || blank, invoiceSchema);

    const handleAdd = async () => {
        await validate("#container").then(async (result) => {
            if (result) {
                props.onChange(invoice);
                setInvoice(blank);
            }
        });
    }

    useEffect(() => {
        if (typeof (props.errors) !== 'undefined') {
            errors.invoiceNumber = props.errors
        }

    }, [props.errors])

    useEffect(() => {
        setInvoice(blank);
        errors.invoiceNumber = '';
    }, [props.counter])

    return <>
        <div id="container">
            <Label label="What is your invoice or renewal notice number?" id="number" className="mb-3" error={errors.invoiceNumber}>
                <TextInput value={invoice.invoiceNumber ?? ""} placeholder="Enter your 9-digit notice number here" onChange={v => setInvoice({ invoiceNumber: v })} size={"block"} maxLength={9} />
            </Label>
            <div className="d-flex">
                <Button disabled={props.disabled} label={props.r ? "Update" : "Add notice/invoice"} onClick={() => handleAdd()}  />
            </div>
        </div>
    </>
}